// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    MORTGAGE_INPUT_CONTAINER: 'mortgage_input_container',
    MORTGAGE_INPUT: 'mortgage_input_',
    MORTGAGE_INPUT_ERROR_ICON: 'mortgage_input_error_icon_',
};